// import { TREZOR_ADDRESS_VALIDATOR_PACKAGE, WALLET_VALIDATOR_PACKAGE } from './constants'

export const WALLET_VALIDATOR_PACKAGE = 'wallet-validator'
export const TREZOR_ADDRESS_VALIDATOR_PACKAGE = 'trezor-address-validator'

export const USDC_NETWORKS = [
  {
    fullName: 'usdc-ethereum',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'ethereum',
    networkShortName: 'ETH',
    code: 'ERC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-binance-smart-chain',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'binance-smart-chain',
    networkShortName: 'BSC',
    code: 'bsc',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-algo',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'algorand',
    networkShortName: 'ALGO',
    code: 'algo',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-avax',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'avalanche',
    networkShortName: 'AVAX',
    code: 'avx',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-flow',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'flow',
    networkShortName: 'FLOW',
    code: 'flw',
    validator: null
  },
  {
    fullName: 'usdc-hbar',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'hedera',
    networkShortName: 'HBAR',
    code: 'hbr',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-sol',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'solana',
    networkShortName: 'SOL',
    code: 'sol',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-xlm',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'stellar-lumens',
    networkShortName: 'XLM',
    code: 'xlm',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdc-trx',
    shortName: 'usdc',
    currency: 'USDC',
    network: 'tron',
    networkShortName: 'TRX',
    code: 'TRC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const USDT_NETWORKS = [
  {
    fullName: 'usdt-ethereum',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'ethereum',
    networkShortName: 'ETH',
    code: 'ERC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-binance-smart-chain',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'binance-smart-chain',
    networkShortName: 'BSC',
    code: 'bsc',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-algo',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'algorand',
    networkShortName: 'ALGO',
    code: 'algo',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-avax',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'avalanche',
    networkShortName: 'AVAX',
    code: 'avx',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-flow',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'flow',
    networkShortName: 'FLOW',
    code: 'flw',
    validator: null
  },
  {
    fullName: 'usdt-hbar',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'hedera',
    networkShortName: 'HBAR',
    code: 'hbr',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-sol',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'solana',
    networkShortName: 'SOL',
    code: 'sol',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-xlm',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'stellar-lumens',
    networkShortName: 'XLM',
    code: 'xlm',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'usdt-trx',
    shortName: 'usdt',
    currency: 'USDT',
    network: 'tron',
    networkShortName: 'TRX',
    code: 'TRC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const BUSD_NETWORKS = [
  {
    fullName: 'busd-ethereum',
    shortName: 'busd',
    currency: 'BUSD',
    network: 'ethereum',
    networkShortName: 'ETH',
    code: 'ERC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'busd-algo',
    shortName: 'busd',
    currency: 'BUSD',
    network: 'algorand',
    networkShortName: 'ALGO',
    code: 'algo',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'busd-avax',
    shortName: 'busd',
    currency: 'BUSD',
    network: 'avalanche',
    networkShortName: 'AVAX',
    code: 'avx',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'busd-binance-smart-chain',
    shortName: 'busd',
    currency: 'BUSD',
    network: 'binance-smart-chain',
    networkShortName: 'BSC',
    code: 'bsc',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'busd-trx',
    shortName: 'busd',
    currency: 'BUSD',
    network: 'tron',
    networkShortName: 'TRX',
    code: 'TRC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const DAI_NETWORKS = [
  {
    fullName: 'dai-ethereum',
    shortName: 'dai',
    currency: 'DAI',
    network: 'ethereum',
    networkShortName: 'ETH',
    code: 'ERC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-algo',
    shortName: 'dai',
    currency: 'DAI',
    network: 'algorand',
    networkShortName: 'ALGO',
    code: 'algo',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-avax',
    shortName: 'dai',
    currency: 'DAI',
    network: 'avalanche',
    networkShortName: 'AVAX',
    code: 'avx',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-flow',
    shortName: 'dai',
    currency: 'DAI',
    network: 'flow',
    networkShortName: 'FLOW',
    code: 'flw',
    validator: null
  },
  {
    fullName: 'dai-hbar',
    shortName: 'dai',
    currency: 'DAI',
    network: 'hedera',
    networkShortName: 'HBAR',
    code: 'hbr',
    validator: TREZOR_ADDRESS_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-sol',
    shortName: 'dai',
    currency: 'DAI',
    network: 'solana',
    networkShortName: 'SOL',
    code: 'sol',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-xlm',
    shortName: 'dai',
    currency: 'DAI',
    network: 'stellar-lumens',
    networkShortName: 'XLM',
    code: 'xlm',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    fullName: 'dai-trx',
    shortName: 'dai',
    currency: 'DAI',
    network: 'tron',
    networkShortName: 'TRX',
    code: 'TRC-20',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const SWAP_ASSETS_NETWORKS = [
  ...USDC_NETWORKS,
  ...USDT_NETWORKS,
  ...BUSD_NETWORKS,
  ...DAI_NETWORKS
]
export const BARE_ASSETS = ['usdt', 'usdc', 'busd', 'dai']
